<template>
    <div class="central-content">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "Cover"
};
</script>

<style lang="scss" scoped>
.central-content {
    width: 100%;
    background: #ffffff;
    border-radius: 10px;
    padding: 40px 20px;
}

@media (max-width: 812px) {
    .central-content {
        margin: 20px 0;
    }
}

.central-content h5 {
    margin-bottom: 24px;
    text-align: center;
}

@media (max-width: 812px) {
    .central-content h5 {
        font-size: 18px;
        color: white;
        margin-bottom: 16px;
    }
}

.central-content .button-regular {
    width: 100%;
}

.central-content .form-group {
    margin-bottom: 0;
}

.central-content .form-group:nth-child(n + 2) {
    margin-top: 24px;
}
</style>
